import { useLocation } from 'react-router-dom';
import { AppRoutes } from '@/utils';

export const useIsAggregatedConsentPages = () => {
  const location = useLocation();
  return location.pathname.includes(AppRoutes.AGGREGATED_CONSENT_GROUP);
};
